exports.components = {
  "component---src-templates-site-jsx": () => import("./../../../src/templates/site.jsx" /* webpackChunkName: "component---src-templates-site-jsx" */)
}

